import { Languages } from 'modules/core/enums/languages';
import { Integrations } from './../enums/integrations';

export class WizardQueryParams {
  public type: Integrations;
  public email?: string;
  public phone?: string;
  public callback?: string;
  public domain?: string;
  public lang?: Languages;
  public name?: string;
  public clientId?: string;
  public clientSecret?: string;
  public authorizationCode?: string;
  public apiEndpoint?: string;
  public timestamp?: string;
  public hash?: string;
  public place?: string;


  public constructor(query?: any) {
    console.log("phone", JSON.stringify(query.phone))
    this.type = query.type ? query.type as Integrations : Integrations.CUSTOM;
    this.callback = query.callback ? query.callback as string : undefined;
    this.phone = query.phone ? this.parsePhone(query.phone) as string : undefined;
    this.email = query.email ? query.email as string : undefined;
    this.lang = Object.values(Languages).includes(query.lang) ? query.lang as Languages : Languages.PL;
    this.domain = query.domain ? query.domain as string : undefined;
    this.name = query.name ? query.name as string : undefined;
    this.clientId = query.clientId ? query.clientId as string : undefined;
    this.clientSecret = query.clientSecret ? query.clientSecret as string : undefined;
    this.authorizationCode = query.authorizationCode ? query.authorizationCode as string : undefined;
    this.apiEndpoint = query.apiEndpoint ? query.apiEndpoint as string : undefined;
    this.timestamp = query.timestamp ? query.timestamp as string : undefined;
    this.hash = query.hash ? query.hash as string : undefined;
    this.place = query.place ? query.place as string : undefined;
  }
  private parsePhone(phone: string) : string
  {
    let parsed = phone.trim();
    if(parsed[0] != '+')
    {
      return '+' + parsed
    }
    return parsed;
  }
}
